<div [formGroup]="messageToUserForm" class="d-flex flex-column form-group m-4">
    <div class="d-flex flex-row align-items-center">
        <div class="align-self-center mr-1">{{ 'USERMANAGEMENT.MESSAGE_MODAL.MESSAGE_TO' | translate }}:</div>
        <ng-container *ngrxLet="selectedUsers$; let selectedUsers">
            <div class="d-flex flex-row selected-user rounded-pill pt-1 pb-1 mr-2 pl-2 pr-2" *ngFor="let user of selectedUsers.data">
                <div class="align-self-center mr-1">{{ user.firstName }} {{ user.lastName }}</div>
                <button type="button" class="btn delete-user-recipient" (click)="removeSelectedUser(user, selectedUsers.totalRecords)">
                    <div class="d-flex h-100"><i class="pi pi-times align-self-center"></i></div>
                </button>
            </div>
        </ng-container>
    </div>
    <div class="mt-3">
        <label id="cc" for="ccInout">{{ 'USERMANAGEMENT.MESSAGE_MODAL.CC_MESSAGE_TO' | translate }}</label>
        <input id="ccInout" class="form-control" formControlName="cc" type="text" />
        <div *ngIf="email?.invalid && (email?.dirty || email?.touched)" style="font-size: small" class="text-danger pt-1">
            <div *ngIf="email?.errors?.['email']">{{ 'VALIDATION_EMAIL' | translate }}</div>
        </div>
    </div>
    <div class="mt-3">
        <label id="title" for="titleInout">{{ 'USERMANAGEMENT.MESSAGE_MODAL.TITLE_INPUT' | translate }}</label>
        <input class="form-control" id="titleInout" formControlName="title" type="text" />
    </div>
    <div class="mt-3">
        <label id="text" for="textInout">{{ 'USERMANAGEMENT.MESSAGE_MODAL.MESSAGE_INPUT' | translate }}</label>
        <angular-markdown-editor id="textInout" textareaId="descriptionEditor" [options]="editorOptions" formControlName="text"></angular-markdown-editor>
    </div>
</div>
<div class="dialog-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="close()">
        {{ 'CORE_BUTTON_CANCEL' | translate }}
    </button>
    <button type="button" class="btn btn-primary save" (click)="save()" [disabled]="text!.value.length <= 0">
        {{ 'CORE_BUTTON_SEND' | translate }}
    </button>
</div>
